/* VFW Spotlight — story stage + lightbox (2026-09-30).
   Two small custom elements, no libraries (motion law §8).
   <vfw-sp-story>: on wide screens, one sticky photo follows the chapter the
   reader is on. Every chapter already carries its own photo inline, so
   without JS (or on phones) nothing is lost.
   <vfw-sp-gallery>: thumbnails open a native <dialog> lightbox with
   previous/next, arrow keys, swipe, Escape and focus return. */
(function () {
  if (typeof customElements === 'undefined') return;

  class VfwSpStory extends HTMLElement {
    connectedCallback() {
      if (this._on) return;
      this._on = true;
      const frames = [...this.querySelectorAll('.vfw-sp__stage-frame')];
      const chapters = [...this.querySelectorAll('.vfw-sp__chapter')];
      if (!frames.length || !chapters.length || typeof IntersectionObserver === 'undefined') return;
      this.classList.add('is-staged');
      const show = (n) => {
        frames.forEach((f) => f.classList.toggle('is-active', f.dataset.chapter === n));
        chapters.forEach((c) => c.classList.toggle('is-current', c.dataset.chapter === n));
      };
      show(chapters[0].dataset.chapter);
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((e) => { if (e.isIntersecting) show(e.target.dataset.chapter); });
        },
        { rootMargin: '-45% 0px -45% 0px' }
      );
      chapters.forEach((c) => io.observe(c));
    }
  }

  class VfwSpGallery extends HTMLElement {
    connectedCallback() {
      if (this._on) return;
      this._on = true;
      this.thumbs = [...this.querySelectorAll('.vfw-sp__thumb')];
      this.dlg = this.querySelector('.vfw-sp__lightbox');
      if (!this.dlg || typeof this.dlg.showModal !== 'function') return;
      this.img = this.dlg.querySelector('.vfw-sp__lb-img');
      this.count = this.dlg.querySelector('.vfw-sp__lb-count');
      this.i = 0;
      this.thumbs.forEach((t, n) => t.addEventListener('click', () => this.open(n, t)));
      this.dlg.querySelectorAll('[data-step]').forEach((b) =>
        b.addEventListener('click', () => this.go(this.i + Number(b.dataset.step))));
      this.dlg.querySelector('[data-close]').addEventListener('click', () => this.dlg.close());
      this.dlg.addEventListener('click', (e) => { if (e.target === this.dlg) this.dlg.close(); });
      this.dlg.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') { e.preventDefault(); this.go(this.i + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(this.i - 1); }
      });
      this.dlg.addEventListener('close', () => {
        document.documentElement.classList.remove('vfw-sp-locked');
        if (this.opener) this.opener.focus();
      });
      let x0 = null;
      this.dlg.addEventListener('pointerdown', (e) => { x0 = e.clientX; });
      this.dlg.addEventListener('pointerup', (e) => {
        if (x0 === null) return;
        const dx = e.clientX - x0; x0 = null;
        if (Math.abs(dx) > 50) this.go(this.i + (dx < 0 ? 1 : -1));
      });
    }
    open(n, opener) {
      this.opener = opener;
      this.go(n);
      document.documentElement.classList.add('vfw-sp-locked');
      this.dlg.showModal();
    }
    go(n) {
      const len = this.thumbs.length;
      this.i = (n + len) % len;
      const t = this.thumbs[this.i];
      this.img.src = t.dataset.full;
      this.img.alt = t.dataset.alt || '';
      this.count.textContent = (this.i + 1) + ' / ' + len;
    }
  }

  if (!customElements.get('vfw-sp-story')) customElements.define('vfw-sp-story', VfwSpStory);
  if (!customElements.get('vfw-sp-gallery')) customElements.define('vfw-sp-gallery', VfwSpGallery);
})();
